import { Location } from '@angular/common';
import { Component, inject } from '@angular/core';

@Component({
  selector: 'app-no-autorizado',
  standalone: true,
  templateUrl: './no-autorizado.html',
  styleUrl: './no-autorizado.css',
})
export class NoAutorizadoComponent {
  private readonly location = inject(Location);

  protected volver(): void {
    this.location.back();
  }
}
